import React from 'react';

export enum BubbleType {
  RED,
  GREEN,
  YELLOW,
}
export interface BubbleDatamodel {
  text: string;
  type: BubbleType;
}

const getColor = (
  bubbleType: BubbleType,
): { backgroundColor: string; color: string } => {
  switch (bubbleType) {
    case BubbleType.GREEN:
      return {
        backgroundColor: 'rgb(67,182,120)',
        color: '#FFFFFF',
      };
    case BubbleType.YELLOW:
      return {
        backgroundColor: 'rgba(249,160,8,0.25)',
        color: '#915B00',
      };
    case BubbleType.RED:
      return {
        backgroundColor: 'rgba(224,0,0,0.15)',
        color: '#E00000',
      };
  }
};
const BubbleText: React.FC<BubbleDatamodel> = ({ text, type }) => {
  const colorData = getColor(type);
  return (
    <div
      style={{
        width: 'fit-content',
        display: 'flex',
        alignItems: 'center',
        background: colorData.backgroundColor,
        padding: '4px 12px',
        borderRadius: 20,
        fontSize: 15,
      }}
    >
      <div
        style={{
          color: colorData.color,
          display: 'flex',
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default BubbleText;
